import React, { useState, useRef, useEffect } from 'react';
import FsLightbox from 'fslightbox-react';
import { doc } from 'prettier';
import { useLockBodyScroll, useToggle } from 'react-use';

const PostImage = ({ additionalClass, orginal, srcset, image, handleItemClick, ind, style, imgStyle }) => {
  const [toggler, setToggler] = useState(false);
  const node = useRef();
  const [locked, toggleLocked] = useToggle(false)

  useLockBodyScroll(locked);
  const handleItemClickBound = ind => {
    if (handleItemClick) {
      handleItemClick(ind);
    }
  };


  const handleClick = e => {

    if (node.current.contains(e.target)) {
      toggleLocked(true)
      return;
    }
    // outside click 
    toggleLocked(false)


  };
  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };

  }, []);

  return (
    <div
      className={`post-img-cont-wrapper ` + additionalClass}
      style={{ ...style }}
      onClick={() => handleItemClickBound(ind)}
    >
      <button type="button" ref={node} style={{ ...imgStyle }} onClick={() => { setToggler(!toggler) }}>
        <img className="post-img-cont pointer-cursor" src={image} srcSet={srcset ? srcset : orginal} />
      </button>
      <FsLightbox
        toggler={toggler}
        sources={[<img className="post-img-cont pointer-cursor" src={image} srcSet={srcset ? srcset : orginal} />]}
      />
    </div>
  );
};

export default PostImage;
